import * as hooks from '@owl-nest/hooks'

export function getCurrentLocale(
  router: hooks.NextRouter,
): hooks.NextRouter['locale'] | hooks.NextRouter['defaultLocale'] {
  return router.locale ?? router.defaultLocale
}
